/**
 * Skip Navigation Component
 * Allows keyboard users to skip to main content
 */

import { cn } from '@/utils/classNames';
import { usePreferences } from '@/context/PreferencesContext';

export function SkipNavigation() {
  const { preferences } = usePreferences();

  if (!preferences.screenReaderOptimized) {
    return null;
  }

  return (
    <a
      href="#main-content"
      className={cn(
        'sr-only focus:not-sr-only',
        'fixed left-4 top-4 z-[9999]',
        'rounded-lg bg-stellar-primary px-4 py-2',
        'text-white font-semibold',
        'focus:outline-none focus:ring-2 focus:ring-white',
        'focus:ring-offset-2 focus:ring-offset-stellar-primary'
      )}
    >
      Skip to main content
    </a>
  );
}
